import { render, staticRenderFns } from "./TaskActionDropdown.vue?vue&type=template&id=40131ce4&scoped=true&"
import script from "./TaskActionDropdown.vue?vue&type=script&lang=js&"
export * from "./TaskActionDropdown.vue?vue&type=script&lang=js&"
import style0 from "./TaskActionDropdown.vue?vue&type=style&index=0&id=40131ce4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40131ce4",
  null
  
)

/* custom blocks */
import block0 from "./TaskActionDropdown.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports